// extracted by mini-css-extract-plugin
export default {"filterGroup":"ReportServiceVolume_filterGroup__NbZ7S","label":"ReportServiceVolume_label__u3SbC","title":"ReportServiceVolume_title__ljh4A"};